import PropTypes from 'prop-types';
import React, { memo } from 'react';
import css from './TextOnly.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TextOnly = function TextOnly(_ref) {
  var description = _ref.description,
      title = _ref.title,
      textColor = _ref.textColor;
  return /*#__PURE__*/_jsxs("header", {
    className: css.root,
    children: [title && /*#__PURE__*/_jsx("h1", {
      className: css.title,
      dangerouslySetInnerHTML: {
        __html: title
      },
      style: {
        color: textColor
      }
    }), description && /*#__PURE__*/_jsx("p", {
      className: css.description,
      dangerouslySetInnerHTML: {
        __html: description
      },
      style: {
        color: textColor
      }
    })]
  });
};

TextOnly.displayName = 'TextOnly';
TextOnly.defaultProps = {
  description: false,
  textColor: '',
  title: false
};
TextOnly.propTypes = {
  description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  textColor: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default /*#__PURE__*/memo(TextOnly);